var map = {
	"./ar.json": [
		6499,
		499
	],
	"./en.json": [
		2265,
		265
	],
	"./hi.json": [
		4507,
		507
	],
	"./ta.json": [
		76,
		76
	],
	"./te.json": [
		4962,
		962
	],
	"./ur.json": [
		7678,
		678
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3123;
module.exports = webpackAsyncContext;